import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromPackInFocus from './state/pack-in-focus.reducer';
import { PackInFocusFacade } from './state/pack-in-focus.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromPackInFocus.PACK_IN_FOCUS_FEATURE_KEY, fromPackInFocus.packInFocusReducer),
  ],
  providers: [PackInFocusFacade],
})
export class PackInFocusModule {}
